import { jsx, Fragment } from "react/jsx-runtime";
import { Fragment as Fragment$1 } from "react";
import KatexRenderer from "../../utils/KatexRenderer.js";
import { preprocessLegacyMarkup } from "../../utils/textFormatter.js";
const BOLD_TOKEN_PATTERN = /(\*\*[\s\S]+?\*\*)/g;
const COMPLETE_BOLD_TOKEN_PATTERN = /^\*\*([\s\S]+)\*\*$/;
function MathText({ text }) {
  const processed = preprocessLegacyMarkup(text);
  if (processed === text && !processed.includes("$$")) {
    return /* @__PURE__ */ jsx(Fragment, { children: text });
  }
  return /* @__PURE__ */ jsx(KatexRenderer, { text: processed });
}
function LearningContentText({
  text,
  className
}) {
  if (!text) return null;
  const parts = text.split(BOLD_TOKEN_PATTERN);
  const content = /* @__PURE__ */ jsx(Fragment, { children: parts.map((part, index) => {
    if (!part) return null;
    const boldMatch = COMPLETE_BOLD_TOKEN_PATTERN.exec(part);
    if (boldMatch) {
      return /* @__PURE__ */ jsx("strong", { className: "font-bold", children: /* @__PURE__ */ jsx(MathText, { text: boldMatch[1] }) }, index);
    }
    return /* @__PURE__ */ jsx(Fragment$1, { children: /* @__PURE__ */ jsx(MathText, { text: part }) }, index);
  }) });
  return className ? /* @__PURE__ */ jsx("span", { className, children: content }) : content;
}
function renderLearningContentInline(text) {
  if (!text) return [""];
  return [/* @__PURE__ */ jsx(LearningContentText, { text }, "learning-content")];
}
export {
  LearningContentText,
  renderLearningContentInline
};
//# sourceMappingURL=LearningContentText.js.map
